import React, { Component } from 'react';
import { graphql } from 'gatsby';

import REGISTERED_USERS from '../constants/registered_users';

import { capitalise } from '@sayido/utils';

import {
  GraphicSection as Section,
  Title,
  SectionWrapper,
} from '../components/Section';
import ChecklistGraphic from '../components/graphics/checklist';
import CollectionGraphic from '../components/graphics/details-collection';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import Layout from '../components/PageLayout';
// import MatchingInvite from '../components/graphics/matching-invite';
import NumberIncrementer from '../components/NumberIncrementer';
import PhotoSection from '../components/PhotoSection';
import RSVPGraphic from '../components/graphics/rsvp';
import Seo from '../components/seo';
import Testimonials from '../components/Testimonials';
import ThreeColFeatures from '../components/ThreeColFeatures';

import HeroImg from '../images/shared/home-hero1.jpg';
import Img1 from '../images/shared/home-bg.jpg';
import Img2 from '../images/shared/home-bg2.jpg';
import WebsiteImg from '../images/feature-graphics/website-preview1.png';
// import StyledBg1 from '../images/patterns/waves1.svg';

class Index extends Component {
  constructor(props) {
    super(props);
    let dynamicNameInsertion = false;
    let affiliate = false;
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      affiliate = urlParams.get('ref');
      dynamicNameInsertion = urlParams.get('referred_by');

      // if (affiliate) {
      //   window.history.pushState(
      //     '',
      //     'Say I do',
      //     window.location.search.replace(`ref=${affiliate}`, '')
      //   );
      // }
    }
    this.state = {
      dynamicNameInsertion: dynamicNameInsertion,
      affiliate: affiliate || false,
    };
  }
  generateSubtitle() {
    const { dynamicNameInsertion } = this.state;
    const names = !!dynamicNameInsertion ? dynamicNameInsertion.split(',') : null;
    return dynamicNameInsertion
      ? `${capitalise(names[0])} and ${capitalise(
          names[1]
        )} are using Say I do to make their wedding planning a breeze. You
    can too!`
      : 'Plan, organise and master your wedding goals, with everything you need.';
  }
  render() {
    const subtitle = this.generateSubtitle();
    const testimonials = this.props.data.allStrapiTestimonial.nodes;

    return (
      <Layout>
        <Seo title="Custom Wedding Website &amp; Digital RSVP Manager" />

        <Hero
          subtitle={subtitle}
          image={HeroImg}
          alt="Happy couple after planning their wedding"
        />

        <Section
          layout={'alt'}
          title="A free wedding website that's just... you!"
          body="Tell your guests all they need to know about the big day on your customised wedding website - add all your events, photos and videos! All in one of our beautifully designed themes."
          ctaLink="https://sayi.do/oliviapatrickdemo"
          ctaLabel="See A Demo"
          shadow={false}
        >
          <img
            src={WebsiteImg}
            alt="Wedding website preview with custom hue and font selector"
            style={{ maxWidth: '520px' }}
          />
        </Section>

        <Section
          title="The smartest online RSVP"
          body="Guests can easily RSVP on your wedding website using their smart phone or computer. For people who don't have one, you can do it for them."
          ctaLink="https://sayi.do/oliviapatrickdemo/rsvp/QYs2OJz2UJSVU29IarT2JCT7Spj2/40ec1357-3072-14ec-7810-7ce9c8baae36/-1?party=40ec1357-3072-14ec-7810-7ce9c8baae36"
          ctaLabel="Try It Out"
        >
          <RSVPGraphic />
        </Section>

        <PhotoSection
          alt="Couple dancing and smiling at their wedding reception"
          img={Img2}
        />

        <Section
          layout={'alt'}
          title="Collect Contact Details"
          body="Have your guests enter all their contact info straight into your guest list, easy!"
          overflow={true}
          ctaLink="https://sayi.do/oliviapatrickdemo/forms/contact-details/QYs2OJz2UJSVU29IarT2JCT7Spj2/4a8490f9-6410-ba73-d158-5bc1df676374/0000-03f9-eef1-b8d0-accf210cd00a?party=4a8490f9-6410-ba73-d158-5bc1df676374"
          ctaLabel="See How It Works"
        >
          <CollectionGraphic />
        </Section>

        <Section
          title="Ch-ch-check it off!"
          body={`Get access to personalised tools that will hold your hand until you say "I do!"`}
          ctaLabel="Find Out More"
          ctaLink="/wedding-checklist"
          ctaInternal={true}
        >
          <ChecklistGraphic />
        </Section>

        {/* <Section
          animation={false}
          shadow={false}
          styledBg={StyledBg1}
          layout={'alt'}
          title="Fresh designs, matching prints"
          body={`A huge range of designs that fits your theme to a tee – or you can create your own!`}
          ctaLabel="View The Designs"
          ctaLink="/wedding-website/designs"
          ctaInternal={true}
        >
          <MatchingInvite />
        </Section> */}

        <ThreeColFeatures />

        <PhotoSection
          alt={'Married couple embracing romantic wedding moment'}
          img={Img1}
        />

        <SectionWrapper align={'center'} layout={'alt'}>
          <Title as="h3">What others are saying</Title>
          <h4
            style={{
              maxWidth: '300px',
              margin: '0 auto 50px',
              lineHeight: '1.5',
            }}
          >
            Join over <NumberIncrementer start={REGISTERED_USERS} /> couples
            worldwide
            <br />
            who are already using Say I do
          </h4>
          <Testimonials data={testimonials} />
        </SectionWrapper>

        <Footer />

        {/* <AffiliateWelcome affiliate={this.state.affiliate} /> */}
      </Layout>
    );
  }
}

export default Index;

export const query = graphql`
  query {
    ...AllTestimonials
  }
`;
